import firebaseApp from './firebase'; // This is the Firebase object from the previous tutorial
import { getFirestore } from 'firebase/firestore';

const db = getFirestore(firebaseApp, import.meta.env.VITE_DB_NAME);

export default db;
